import { apiClient } from '@/lib/api/client';

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  created: string;
  lastUsed: string | null;
  scope: string[];
}

export interface CreateApiKeyRequest {
  name: string;
  scope: string[];
  organizationId: string;
  tier?: string;
}

export interface CreateApiKeyResponse {
  id: string;
  name: string;
  key: string; // Full key is only returned once
  prefix: string;
  created_at: string;
  scope: string[];
  tier: string;
  organization_id: string;
  warning: string;
}

export async function getApiKeys(organizationId: string) {
  return apiClient.get<ApiKey[]>(`/api/integrations/${organizationId}/api-keys`);
}

export async function createApiKey(organizationId: string, request: CreateApiKeyRequest) {
  // Ensure organizationId matches in request
  const requestWithOrgId = { ...request, organization_id: organizationId };
  return apiClient.post<CreateApiKeyResponse>(`/api/integrations/${organizationId}/api-keys`, requestWithOrgId);
}

export async function deleteApiKey(userId: string, keyId: string) {
  return apiClient.delete(`/api/integrations/${userId}/api-keys/${keyId}`);
}